// Generated from SVG to Code Figma Plugin

import type React from 'react';

export const BaseLineStyleTransfer = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.2506 2.5H8.12562C7.12844 2.5 6.32007 3.30837 6.32007 4.30555V11.5278C6.32007 12.525 7.12844 13.3333 8.12562 13.3333H16.2506C17.2478 13.3333 18.0562 12.525 18.0562 11.5278V8.36806V4.30556C18.0562 3.30837 17.2478 2.5 16.2506 2.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.01562"
    />
    <path
      d="M6.32007 7.91654C9.0284 7.46512 13.5423 8.3679 13.5423 13.3332"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.01562"
    />
    <path
      d="M4.16667 5.83337C3.72464 5.83337 3.30072 6.00897 2.98816 6.32153C2.67559 6.63409 2.5 7.05801 2.5 7.50004V15.8334C2.5 16.2754 2.67559 16.6993 2.98816 17.0119C3.30072 17.3244 3.72464 17.5 4.16667 17.5H12.5C12.942 17.5 13.366 17.3244 13.6785 17.0119C13.9911 16.6993 14.1667 16.2754 14.1667 15.8334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.01667"
    />
    <circle cx="14.5355" cy="5.9983" r="1.29774" stroke="currentColor" strokeWidth="1.01562" />
  </svg>
);
